import { PriceFromStripe } from "../../interfaces/apiRequests/PriceFromStripe";
import { formatPrice } from "../generic";

export function formatPriceFromStripe(
  priceFromStripe: PriceFromStripe,
  showCents = true,
): string {
  const foundStripeService =
    priceFromStripe.subscriptionPlanPaymentProviders.find(
      (provider) => provider.paymentProvider === "stripe",
    );

  return formatPrice(foundStripeService.price, showCents);
}
